import { IS_DEMO, IS_DEMO_CUSTOMER } from "@portal/demo/demoutils";
import { Icon } from "@portal/lib/icons/icons";
import { AppPageParams } from "@portal/lib/router/constants/page-info";
import { Invoice } from "@portal/types/entities/invoice";
import { GrowTypography, QuickOperations } from "@sinecycle/growcomponents";
import { filter, get } from "lodash";
import { useParams } from "react-router-dom";
import { InvoiceActionPrivileges } from "./InvoiceList";

function useQuickOperations(actionPrivileges?: InvoiceActionPrivileges) {
  const { customer_id } = useParams<AppPageParams>();
  const isPayment = customer_id === IS_DEMO_CUSTOMER && IS_DEMO;
  const PTPIcon = <Icon icon={["far", "handshake-simple"]} />;
  const RDIcon = <Icon icon={["far", "comment-times"]} />;
  const PaymentIcon = <Icon icon={["far", "credit-card"]} />;

  const options: QuickOperations<Invoice>["items"] = [
    {
      key: "PTP",
      label: "Promise to pay",
      icon: PTPIcon,
    },
    {
      key: "DISPUTE",
      label: "Raise a dispute",
      icon: RDIcon,
    },
    {
      key: "PAYMENT",
      label: (
        <GrowTypography.Link
          href="https://apisandbox.zuora.com/platform/apps/payment-links/i/inv_rO0ABXd8ADCs7QAFdyoBAAUzMjI0NAAgOTY5MjE0OGUyMWE1NDhmMGI3MWY1OTMyY2I5OGJiMDgASDBGAiEAweFlsw_ZgkiKixAm8EkCUAas8zfq-U57j_f65fWmRTICIQCtA53O4Bkt9qmhJbwXS7Vm6LdVuBTuuDeSEPAgGfbYPQ=="
          target="_blank"
        >
          Pay
        </GrowTypography.Link>
      ),
      icon: PaymentIcon,
    },
  ];

  const getItems = () =>
    filter(
      options,
      (option) =>
        !(
          (!isPayment && option?.key === "PAYMENT") ||
          (!get(actionPrivileges, "ptp") && option?.key === "PTP") ||
          (!get(actionPrivileges, "dispute") && option?.key === "DISPUTE")
        )
    );

  const items = getItems();
  return { items };
}

export { useQuickOperations };
